import { Component, Input } from '@angular/core';
import { AlertService } from '@core/services/alert.service';
import { PolicyService } from '@core/services/policy.service';
import { MaInsuranceCar } from '@shared/models/ma-insurance';
import { GreenCardRequest } from '@shared/models/policies/detail/green-card-request';
import { GreenCardResponse } from '@shared/models/policies/detail/green-card-response';
import { Policy } from '@shared/models/policy';

@Component({
    selector: 'app-green-card',
    templateUrl: './green-card.component.html',
    styleUrls: ['./green-card.component.scss'],
    standalone: false
})
export class GreenCardComponent {
    @Input() policy: Policy;
    @Input() maInsurance: MaInsuranceCar;
    @Input() policyState: string;

    constructor(
        private alertService: AlertService,
        private policyService: PolicyService
    ) {

    }

    generatePzpCard() {
        if(!this.maInsurance.vehicle.category || this.policy.lineOfBusinessId !== 8){
            this.alertService.warn('Neplatné dáta');
            return;
        }

        let greenCardRequest = new GreenCardRequest();

        greenCardRequest.brand = this.maInsurance.vehicle.brand;
        greenCardRequest.category = this.maInsurance.vehicle.category;
        greenCardRequest.crn = this.maInsurance.vehicle.crn;
        greenCardRequest.policyNumber = this.policy.policyNumber;
        greenCardRequest.beginDate = this.policy.beginDate;
        greenCardRequest.dateBeginOrig = this.policy.dateBeginOrig;
        greenCardRequest.endDate = this.policy.endDate;

        this.policyService.generateGreenCard(greenCardRequest).subscribe( (response: GreenCardResponse) => {
            this.policyService.getGreenCard(response.uuid);
        })
    }

}
